import {mapActions} from "vuex";
import * as moment from "moment";

export default {
    data(){
        return {
            isNeedToUpdateBaseData: false,
            updateReportData: false,
            isFiltersLoadingStart: false,
            baseDataLoaded: false
        }
    },
    created() {
        this.setReportData([]);

        this.$store.watch(() => this.getReportColumns(), (columns) => this.updateColumns(columns));
        this.$store.watch(() => this.getUpdatingStatus(), (isNeedToUpdate) => this._getReportData(isNeedToUpdate));
    },
    beforeMount(){
        this.startLoading();
        this._getBaseData();
    },
    mounted(){
        let filtersList = this.$store.getters[this.namespace + '/getFilters'];

        if (filtersList.reportColumns.length)
        {
            this.setReportColumns(filtersList.reportColumns);
        }
        else
        {
            this.setReportColumns(this.defaultColumns.filter(column => column.checked));
        }

        if (filtersList.filters.paginationItemsLimit !== undefined)
        {
            this.setReportPaginationFilter(parseInt(filtersList.filters.paginationItemsLimit));
        }

        if (filtersList.search !== undefined && filtersList.search !== null)
        {
            this.search = filtersList.search;
            this.setReportSearch(filtersList.search);
        }

        if (this.updateReportData)
        {
            this._getReportData(true);
        }
    },
    computed: {

    },
    methods: {
        ...mapActions({
            setReportColumns(dispatch, payload){
                return dispatch(this.namespace + '/setReportColumns', payload);
            },
            _getReportDataFromAPI(dispatch, payload){
                return dispatch(this.namespace + '/getReportDataFromAPI', payload);
            },
            _getSummaryDataFromAPI(dispatch, payload){
                return dispatch(this.namespace + '/getSummaryDataFromAPI', payload);
            },
            setReportData(dispatch, payload){
                return dispatch(this.namespace + '/setReportData', payload);
            },
            setReportSummaryData(dispatch, payload){
                return dispatch(this.namespace + '/setReportSummaryData', payload);
            },
            setReportTotalCount(dispatch, payload){
                return dispatch(this.namespace + '/setReportTotalCount', payload, {root: true});
            },
            setReportPaginationInfo(dispatch, payload){
                return dispatch(this.namespace + '/setReportPaginationInfo', payload);
            },
            setUpdatingStatus(dispatch, payload){
                return dispatch(this.namespace + '/setUpdatingStatus', payload);
            },
            setReportPaginationFilter(dispatch, payload){
                return dispatch(this.namespace + '/setReportPaginationFilter', payload);
            },
            setReportSearch(dispatch, payload){
                return dispatch(this.namespace + '/setReportSearch', payload);
            },
            startLoading(dispatch){
                return dispatch(this.namespace + '/startLoading');
            },
            finishLoading(dispatch){
                return dispatch(this.namespace + '/finishLoading');
            }
        }),
        getReportColumns(){
            return this.$store.getters[this.namespace + '/getReportColumns'];
        },
        getReportFilters(){
            return this.$store.getters[this.namespace + '/getFilters'];
        },
        getCustomReportFilters() {
            return {};
        },
        getPagination(){
          return this.$store.getters[this.namespace + '/getPagination'];
        },
        getUpdatingStatus(){
            return this.$store.getters[this.namespace + '/getUpdatingStatus'];
        },
        getReportDataGetter(){
            return this.$store.getters[this.namespace + '/getReportDataGetter'];
        },
        getReportSummaryData(){
            return this.$store.getters[this.namespace + '/getReportSummaryData'];
        },
        getSideBarStatus(){
            return this.$store.getters.getSideBarStatus;
        },
        getLoadingStatus(){
            return this.$store.getters[this.namespace + '/getLoadingStatus'];
        },
        getSortColumn(){
            return this.$store.getters[this.namespace + '/getSortColumn'];
        },
        getSortDirection(){
            return this.$store.getters[this.namespace + '/getSortDirection'];
        },
        updateColumns: function(columns){
            this.columns = columns;
        },
        _getBaseData() {
            var that = this;

            let objects = null;
            let saveDataInSessionStorage = false;

            if (this.$session.exists('baseData') && this.isNeedToUpdateBaseData)
            {
                objects = Promise((resolve, reject) => { return this.$session.get('baseDate') });
            }
            else
            {
                objects = this.$store.dispatch('getBaseData', null, {root: true});
                this.$session.remove('getBaseData');
                saveDataInSessionStorage = true;
            }

            objects.then(function(result)
            {
                if (saveDataInSessionStorage)
                {
                    that.$session.set('getBaseData', result);
                }

                if (result !== undefined)
                {
                    if (result.sites !== undefined && result.sites.edges.length > 0) {
                        that._storeSites(result.sites.edges);
                    }

                    if (result.partners !== undefined && result.partners.edges.length > 0) {
                        that._storeSources(result.partners.edges);
                    }

                    if (result.markets !== undefined && result.markets.edges.length > 0) {
                        that._storeMarkets(result.markets.edges);
                    }

                    if (result.devices !== undefined && result.devices.edges.length > 0) {
                        that._storeDevices(result.devices.edges);
                    }

                    that._updateParameters();
                    that.finishLoading();
                    that.setUpdatingStatus(true);
                }
            });
        },
        _getReportData(isNeedToUpdate){
            var that = this;

            if (isNeedToUpdate)
            {
                let filtersData = {
                    reportFilters: null,
                    sorting: {
                        sortColumn: null,
                        sortDirection: null
                    }
                };

                filtersData.reportFilters = this.getReportFilters();
                filtersData.columns = this.getReportColumns();
                filtersData.paginationData = this.getPagination();
                filtersData.sorting.sortColumn = this.getSortColumn();
                filtersData.sorting.sortDirection = this.getSortDirection();
                filtersData.isBaseDataLoaded = this.baseDataLoaded;

                let report  = this._getReportDataFromAPI(filtersData);
                let summary = this._getSummaryDataFromAPI(filtersData);

                summary.then(function(result)
                {
                    if (result && result.summary !== undefined) {
                        that.setReportSummaryData(result.summary.edges);
                    }
                }).catch(function (thr) {
                    console.log(thr);
                });

                report.then(function(result)
                {
                    if (result && result.report !== undefined && result.report !== null)
                    {
                        that.setReportData(result.report.edges);
                        that.setReportTotalCount(result.report.totalCount);
                        that.setReportPaginationInfo(result.report.pageInfo);
                        if (result.summary !== undefined) {
                            that.setReportSummaryData(result.summary.edges);
                        }
                    }
                    else
                    {
                        that.$notification.showWarning('API Error!', 'Something is wrong');
                    }
                }).finally(function(){
                    that.finishLoading();
                });
            }

            this.setUpdatingStatus(false);
        },
        showNofiticationEmptyData(){
            this.initNotification();
            this.$notification.showWarning('Warning!', 'There are no data for these filters');
        },
        showNotificationEmptyFilters(){
            this.initNotification();
            this.$notification.showInfo('Info!', 'Please choose filters');
        },
        _storeSites(result){
            let sites = result.map(item => item.node);
            this.$store.dispatch('setSitesList', sites, {root: true});
        },
        _storeSources(result){
            let partners = result.map(item => item.node);
            this.$store.dispatch('setPartnersList', partners, {root: true})
        },
        _storeMarkets(result){
            let markets = result.map(item => item.node);
            this.$store.dispatch('setMarketsList', markets, {root: true});
        },
        _storeDevices(result){
            let devices = result.map(item => item.node);
            this.$store.dispatch('setDevicesList', devices, {root: true});
        },
        _updateParameters(){
            let filtersList = this.$store.getters[this.namespace + '/getFilters'];
            let filters = filtersList.filters;

            if (
                filters.siteId !== undefined && filters.siteId.length > 0 &&
                filters.sourceId !== undefined && filters.sourceId.length > 0 &&
                filters.dateRange.startDate !== null && filters.dateRange.endDate !== null
            ) {
                this.$store.dispatch(this.namespace + '/setUpdatingStatus', true);
                this.$store.dispatch(this.namespace + '/setChartUpdatingStatus', true);
                this.updateReportData = true;
            }

            this.baseDataLoaded = true;
        },
        initNotification() {
            this.$notification.setPosition('topRight')
                .setCloseStatus(true)
                .setCloseOnClick(true)
                .setCloseOnEscape(true)
                .setTimeout(false)
                .setSettings();
        }
    },
};



// WEBPACK FOOTER //
// ./src/components/mixins/baseReportMixin.js